import { ArchivedWorkItemsPage } from '@/features/work-items/pages/ArchivedWorkItemsPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/$wsSlug/projects/$projectSlug/archivadas')({
  component: ArchivedWorkItemsPage,
});
